/** Kamera-Modi: Freie Ansicht oder Flotten-Follow. */
export const enum CameraMode { Free, FlightView }
